import { gql, useMutation } from '@apollo/client';

import { GET_ASSIGNED_TIME_STRIPES } from './get-time-stripes.hook';

const UPDATE_TIME_STRIPE = gql`
  mutation ($payload: UpdateTimeStripeInput!) {
    updateTimeStripe(payload: $payload) {
      type
      conflicts
    }
  }
`;

export const useUpdateTimeStripe = ({ onSuccess }: { onSuccess?: (value: any) => void } = {}) => {
  const [updateTimeStripe, { loading }] = useMutation(UPDATE_TIME_STRIPE, {
    refetchQueries: [GET_ASSIGNED_TIME_STRIPES],
    onCompleted: onSuccess,
  });

  return {
    loading,
    updateTimeStripe: (payload: any) => updateTimeStripe({ variables: { payload } }),
  };
};
